module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};



// WEBPACK FOOTER //
// webpack:///node_modules/core-js/internals/fails.js